import styles from './HeaderDietFoodType.module.scss'

type Props = {
  title: string
}

export const HeaderDietFoodType = ({ title }: Props) => {
  return (
    <div className={styles.root}>
      <h3 className={styles.header}>{title}</h3>
    </div>
  )
}

